import { MapStateToPropsParam } from 'react-redux';

export interface HocOptions {
  connectRedux?: ConnectRedux;
  connectForm?: ConnectForm;
  connectJss?: ConnectJss;
  permissionOptions?: {
    negotiable?: string[];
    nonNegotiable?: string[];
  };
  connectRouter?: boolean;
  useInquiryMasterData?: boolean;
  ignoreWithAuth?: boolean;
}

type ConnectRedux = {
  useRedux: boolean;
  mapStateToProps?: MapStateToPropsParam<any, any>;
  mapDispatchToProps?: Record<string, any>;
};

type ConnectForm = {
  useForm: boolean;
  formOptions?: any;
};

type ConnectJss = {
  useJss: boolean;
  styleSheet: any;
};

export enum PermissionTypes {
  CONTAINER_TRACKING_WRITE = 'CONTAINER_TRACKING_WRITE',
  CONTAINER_TRACKING_EDIT_DELETE_ALL = 'CONTAINER_TRACKING_EDIT_DELETE_ALL',
  CONTAINER_TRACKING_ACCESS_ALL_SHIPMENT = 'CONTAINER_TRACKING_ACCESS_ALL_SHIPMENT',
  CT_NEW_SHIPMENT_VIEW = 'CT_NEW_SHIPMENT_VIEW',
  SHIPMENT_ADD_EDIT = 'SHIPMENT_ADD_EDIT',
  INQUIRY_ALL_ACTIONS = 'INQUIRY_ALL_ACTIONS',
  INQUIRY_CREATE_UPDATE_ACTIONS = 'INQUIRY_CREATE_UPDATE_ACTIONS',
  ORGANISATION_SIZE_NOT_SME = 'ORGANISATION_SIZE_NOT_SME',
  USER_MANAGEMENT_WRITE = 'USER_MANAGEMENT_WRITE',
}
